export default __webpack_public_path__ + "static/media/icon.camping mats.e4ff9117.svg";